import { inject, Injectable } from '@angular/core';
import { GgProductBundlesAdapter } from './gg-product-bundles.adapter';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BundleGroupWsDTO } from '../../model/bundles.model';
import { Observable, throwError } from 'rxjs';
import { ConverterService, LoggerService, normalizeHttpError, Occ, OccEndpointsService } from '@spartacus/core';
import { catchError, tap } from 'rxjs/operators';
import CartModification = Occ.CartModification;
import { CART_MODIFICATION_NORMALIZER } from '@spartacus/cart/base/root';

@Injectable({
  providedIn: 'root',
})
export class OccProductBundlesAdapter implements GgProductBundlesAdapter {
  protected logger = inject(LoggerService);

  constructor(
    private http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converterService: ConverterService
  ) {}

  addBundleToCart(cartId: string, userId: string, bundleGroup: BundleGroupWsDTO): any | Observable<CartModification> {
    const url = this.occEndpoints.buildUrl('addBundle', {
      urlParams: { cartId, userId },
    });

    // Build the request parameters
    const params = new HttpParams();
    // no params in this case

    // Make the POST request
    return this.http.post<CartModification>(url, bundleGroup, { params }).pipe(
      this.converterService.pipeable(CART_MODIFICATION_NORMALIZER),
      catchError((error) => throwError(normalizeHttpError(error, this.logger)))
    );
  }

  removeBundleFromCart(userId: string, cartId: string, entryNumbers: number[]): Observable<any> {
    const url = this.occEndpoints.buildUrl('removeBundle', {
      urlParams: { cartId, userId },
      queryParams: { entryNumbers },
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http
      .delete<CartModification>(url, { headers })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
